import Form from 'react-bootstrap/Form';

function ProspectsSearchForm({ setSearch }) {
  const searchKey = e => {
    if (e.charCode === 13) {
      setSearch(e.target.value);
    }
  };

  return (
    <Form.Control
      className="bo-search"
      type="search"
      name="search"
      id="search"
      placeholder="Search"
      onKeyPress={searchKey}
    />
  );
}

export default ProspectsSearchForm;
